import React from 'react';
import { useParams } from 'react-router-dom';
import Step1BusinessDetails from './steps/Step1BusinessDetails';
import Step2DesignPreferences from './steps/Step2DesignPreferences';
import Step3BrandAssets from './steps/Step3BrandAssets';
import Step4WebsiteContent from './steps/Step4WebsiteContent';
import Step5TargetAudience from './steps/Step5TargetAudience';
import Step6TechnicalRequirements from './steps/Step6TechnicalRequirements';
import Step7ReviewSubmission from './steps/Step7ReviewSubmission';

function FormStep() {
  const { stepId } = useParams();
  const stepNumber = parseInt(stepId) || 1;

  const renderStep = () => {
    switch (stepNumber) {
      case 1:
        return <Step1BusinessDetails />;
      case 2:
        return <Step2DesignPreferences />;
      case 3:
        return <Step3BrandAssets />;
      case 4:
        return <Step4WebsiteContent />;
      case 5:
        return <Step5TargetAudience />;
      case 6:
        return <Step6TechnicalRequirements />;
      case 7:
        return <Step7ReviewSubmission />;
      default:
        return <Step1BusinessDetails />;
    }
  };

  return (
    <div className="form-container px-4 py-8">
      {renderStep()}
    </div>
  );
}

export default FormStep;